import { Tag as AntTag, type TagProps } from 'antd';
import type { FC } from 'react';

type Props = TagProps;

export const Tag: FC<Props> = (props) => {
  return <AntTag {...props} />;
};
